import { render, staticRenderFns } from "./ResumeSidebar.vue?vue&type=template&id=95a22884"
import script from "./ResumeSidebar.vue?vue&type=script&lang=ts"
export * from "./ResumeSidebar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95a22884')) {
      api.createRecord('95a22884', component.options)
    } else {
      api.reload('95a22884', component.options)
    }
    module.hot.accept("./ResumeSidebar.vue?vue&type=template&id=95a22884", function () {
      api.rerender('95a22884', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contractors/ResumeSidebar.vue"
export default component.exports